<template>
	<el-container>

		<el-header class="el-header" style="text-align: right; font-size: 12px">
			<el-button style="float: right;" @click="tologin()">退出登录</el-button>
			<el-button style="float: right;" @click="btnMain()">首页</el-button>

		</el-header>
		<el-container>
			<el-header class="greenmenu">
				<span class="header_h2">{{username}}-{{orderent.OrderName}} </span>
			</el-header>
			<el-main v-if="showmain">
				<!-- <div><span class="spanlabel">{{username}}</span></div> -->
				<el-row>
					<el-col :span="12">
						<button class="bigButton" @click="btnBookList()">预约情况</button>
					</el-col>
					<el-col :span="12">
						<button class="bigButton" @click="btnCheck()">体检情况</button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<button class="bigButton" @click="btnCus()">人员管理</button>
					</el-col>
					<!-- <el-col :span="12">
						<button class="bigButton" @click="btnReport()">查看团报</button>
					</el-col> -->
				</el-row>
			</el-main>
			<router-view>

			</router-view>

		</el-container>
	</el-container>

</template>

<script>
	import order from '../apifunction/Order.js'
	export default {
		created() {
			this.username = this.$myglobal.getUserInfo().username;
			let userid = this.$myglobal.getUserInfo().id;
			order.GetOrderByUserID(userid)
				.then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					if (ent.Flag == 'success') {
						let orderents = JSON.parse(ent.Data)
						if (orderents.length > 0) {
							this.orderent = orderents[0];
						}
					}
				});
			this.showmain = true;
		},
		data() {
			return {
				username: '',
				showmain: false,
				orderent: null
			}
		},
		methods: {
			tologin() {
				this.$store.commit('$_removeStorage');
				this.$router.push('loginbook');
				this.$router.go(0)
			},
			btnMain() {
				this.showmain = true;
				this.$router.push('mainclient');

			},
			btnBookList() {
				if (this.orderent == null) {
					this.$message.info('您账号未开通订单权限，请联系销售！');
					return;
				}
				this.showmain = false;
				var data = {
					path: '/OrderBookList',
					query: {
						ent: JSON.stringify(this.orderent)
					}
				};
				this.$router.push(data);
			},
			btnCheck() {
				if (this.orderent == null) {
					this.$message.info('您账号未开通订单权限，请联系销售！');
					return;
				}
				this.showmain = false;
				var data = {
					path: '/OrderCheck',
					query: {
						ent: JSON.stringify(this.orderent)
					}
				};
				this.$router.push(data);
			},
			btnCus() {
				if (this.orderent == null) {
					this.$message.info('您账号未开通订单权限，请联系销售！');
					return;
				}
				this.showmain = false;
				var data = {
					path: '/ordercusqy',
					query: {
						ent: JSON.stringify(this.orderent)
					}
				};
				this.$router.push(data);
			},
			btnReport() {
				this.showmain = false;
				this.$router.push('OrderReport');
			}
		}
	}
</script>

<style>
</style>
